<rt-divider *ngIf="hasDivider"></rt-divider>
<div class="inner">
  <div class="actions">
    <div class="actions__additional" *ngIf="hasOptionalActions">
      <rt-group>
        <ng-content select="rt-button.optional"></ng-content>
      </rt-group>
    </div>
    <div class="actions__main">
      <rt-group>
        <ng-content select="rt-button:not(.optional)"></ng-content>
      </rt-group>
    </div>
  </div>
</div>
